import script from "./habitSafe.vue?vue&type=script&setup=true&lang=js"
export * from "./habitSafe.vue?vue&type=script&setup=true&lang=js"

import "./habitSafe.vue?vue&type=style&index=0&id=f01141f6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f01141f6"]])

export default __exports__